<template class="max-w-screen">
    <div class="flex font-montserrat flex-col justify-center items-center">
      <HeaderComponent/>
      <div class="relative">
          <div class="lg:h-[80px] h-[50px]"></div>
          <carouselBranding :initial-slide="initialSlide" ></carouselBranding>
          <div class="absolute z-[1000000] text-left bg-black/50 px-[20px] md:px-[50px] text-white top-0 left-0 right-0 bottom-0 w-full flex items-center flex-col justify-center ">
              <h1 class="text-4xl md:text-6xl uppercase text-center font-bold opacity-100">Services</h1>
              
  
          </div>
      </div>
      <div class="container max-w-[1024px]">
        <div class="w-full relative flex justify-center items-center md:mt-[50px] mt-[20px]">
          <div class="container relative w-full md:mt-[10px] mt-[10px] md:mb-[50px] mb-[20px]">
              <h1 class="text-2xl my-[20px] font-bold text-center text-cyan-700 uppercase">
                  services
              </h1>
              <div class="w-full flex relative "> 
                <span @click="goToIndividualPage()"
                :class="{
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  'border-cyan-700': $route.path === '/services'
              }">{{ $t('FI') }}</span>
                <span @click="goToCompaniePage()" :class="{
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  'border-cyan-700': $route.path === '/servicesFCa'
              }">{{ $t('FOC') }}</span> 
              <span @click="goToMPMEPage()" :class="{
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  'border-cyan-700': $route.path === '/servicesMPME'
              }">{{ $t('MPME') }}</span>
              </div>
              <div class="my-[20px] w-full flex relative justify-center items-center flex-wrap">
                <button @click="goToCompaniePage" :class="{
                  'min-w-[300px] w-auto text-center m-[10px] py-[5px] px-[10px] rounded-[5px] border border-gray-500': true, 
                  'bg-cyan-600': $route.path === '/servicesFC'
              }">{{ $t('SDE') }}</button>
                <button @click="goToCompanieEPage" :class="{
                  'min-w-[300px] w-auto text-center m-[10px] py-[5px] px-[10px] rounded-[5px] border border-gray-500': true, 
                  'bg-cyan-600': $route.path === '/servicesFCe'
              }">{{ $t('EVA') }}</button>
                <button @click="goToCompanieAPage" :class="{
                  'min-w-[300px] w-auto text-center m-[10px] py-[5px] px-[10px] rounded-[5px] border border-gray-500': true, 
                  'bg-cyan-600': $route.path === '/servicesFCa'
              }">{{ $t('ALL') }}</button>
            </div>
              <One_service :services="services" />
          </div>
      </div>
      </div>
      
      <FooterComponent/>
    </div>
  </template>
  
  <script setup lang="ts">
  import HeaderComponent from '../components/HeaderComponent.vue'
  import carouselBranding from '../components/CarouselBranding.vue'
  import One_service from '../components/One_service.vue'
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import FooterComponent from '@/components/FooterComponent.vue';
  const router = useRouter()
  const initialSlide = 2;
  
  function goToIndividualPage() {
      router.push('/services')
  }
  function goToCompaniePage() {
      router.push('/servicesFC')
  }
  function goToCompanieEPage() {
      router.push('/servicesFCe')
  }
  function goToCompanieAPage() {
      router.push('/servicesFCa')
  }
  function goToMPMEPage() {
      router.push('/servicesMPME')
  }
  const pageTitle = ref('IronSecur | Nos services'); 
  
  onMounted(() => {
      document.title = pageTitle.value; 
  });
  
  const services = ref([
  {   name: 's9_name', 
      image: '/img/service9.jpg', 
      description: 's9_description', 
      key: ["s9_key1", "s9_key2", "s9_key3", "s9_key4", "s9_key5"] 
 
  },
  {   name: 's10_name', 
      image: '/img/service10.jpg', 
      description: 's10_description', 
      key: ["s10_key1", "s10_key2", "s10_key3", "s10_key4", "s10_key5"] 

  },
  {   name: 's11_name', 
      image: '/img/service11.jpg', 
      description: 's11_description', 
      key: ["s11_key1", "s11_key2", "s11_key3", "s11_key4", "s11_key5"] 

  },
  {   name: 's12_name', 
      image: '/img/service12.jpg', 
      description: 's12_description', 
      key: ["s12_key1", "s12_key2", "s12_key3", "s12_key4", "s12_key5"] 

  },
  {   name: 's13_name', 
      image: '/img/service13.jpg', 
      description: 's13_description', 
      key: ["s13_key1", "s13_key2", "s13_key3", "s13_key4", "s13_key5"] 

  },
  {   name: 's14_name', 
      image: '/img/service14.jpg', 
      description: 's14_description', 
      key: ["s14_key1", "s14_key2", "s14_key3", "s14_key4", "s14_key5"] 

  },
  {   name: 's15_name', 
      image: '/img/service15.jpg', 
      description: 's15_description', 
      key: ["s15_key1", "s15_key2", "s15_key3", "s15_key4", "s15_key5"] 

  },
  {   name: 's16_name', 
      image: '/img/service16.jpg', 
      description: 's16_description', 
      key: ["s16_key1", "s16_key2", "s16_key3", "s16_key4", "s16_key5"] 
 
  },
  ]);
  
  </script>
  
  <style>
  
  </style>